import SimpleBar from "simplebar";

const simplebars = []

const heightpx = window.innerWidth > 1024 ? 102 : 56

document.querySelectorAll(`[data-simplebar]`).forEach((elm) => {
    simplebars.push(new SimpleBar(elm, {
        autoHide: false,
        scrollbarMinSize: heightpx,
        scrollbarMaxSize: heightpx,
    }))
});

let resizeTimeout;

window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
        simplebars.forEach(sb => {
            try {
                sb.recalculate()
            } catch (error) {

            }
        })
    }, 400);
});